/*
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/TypeScriptDataObjectTemplate.ts to edit this template
 */
import { Component, Injectable, ViewChild } from '@angular/core';
import { MaterialListAbstractComponent, MatPaginator, MatSort } 
  from './material-list-abstract.component';

interface IFilters {
    [key: string]: string;
}
export interface IOptionsListFilter {
    id: string,
    description: string
}


// @Component({
//     selector: 'app-material-list-abstract',
//     templateUrl: './material-list-abstract.component.html',
//     styleUrls: ['./material-list-abstract.component.scss']
// })
@Injectable({
    providedIn: 'root'
})
export abstract class AbstractMarterialTableListWithFilter extends MaterialListAbstractComponent {
    public col_filter: any = {};
    private static _filters_sess_names = 'filters';
    private static _static_filters: IFilters = {}
    public static _original_sufix = '_original';

    // -------------------------------------------------------------------------
    override ngOnInit(): void {
        super.ngOnInit();
    }
    
    // =========================================================================
    // -------------------------------------------------------------------------
    get current_filter(): any[] {
        const sess_data: any[] | string | null = sessionStorage.getItem(AbstractMarterialTableListWithFilter._filters_sess_names);
        const saved_data = sess_data ? JSON.parse(<string>sess_data) : [];

        return saved_data;

    }

    // -------------------------------------------------------------------------
    set current_filter(data: any[]) {
        //        console.log('current_filter 1', data);
        //        console.log('current_filter 1', JSON.stringify(data));
        const f_data = data.filter(e => e.value);
        sessionStorage.setItem(
            AbstractMarterialTableListWithFilter._filters_sess_names, 
            JSON.stringify(f_data)
        );

    }

    // =========================================================================
    // ---------------------------------------------------------------------------
    public static resetFilters(): void {

        AbstractMarterialTableListWithFilter._static_filters = {}

    }

    // ---------------------------------------------------------------------------
    public static addFilter(column_name: string, filter_value = ''): void {

        switch (typeof filter_value) {
            case 'string':
                (<any>AbstractMarterialTableListWithFilter._static_filters)[column_name] = filter_value ? filter_value.trim().toLowerCase() : '';
                break;
            default:
                (<any>AbstractMarterialTableListWithFilter._static_filters)[column_name] = filter_value;
                break;
        }

    }

    // ---------------------------------------------------------------------------
    public static getFilterPredicateFuntion(data: any, filter: any): boolean {
        let return_info = true;

        for (let current_column in AbstractMarterialTableListWithFilter._static_filters) {
            const current_filter = AbstractMarterialTableListWithFilter._static_filters[current_column];
            if (current_filter === null || current_filter === '') continue;

            if (!AbstractMarterialTableListWithFilter._validateFilter(current_column, data, current_filter)) {
                return_info = false;
                break;
            }

        }

        return return_info;

    }


    // =========================================================================
    // -------------------------------------------------------------------------
    // Checkear varios fitros en distintas columnas
    // Solo mostrar las filas que cumplan todos los filtros
    public checkfilter($event: any, column_name: string) {
        const $target = <HTMLInputElement>$event.target || null;
        const filter_value = $event.value || $event.value === '' ? $event.value : $target.value;

        this.current_filter = [
            { value: filter_value, column_name: column_name }
        ];

        this._checkfilterValue(filter_value, column_name);

    }

    // -------------------------------------------------------------------------
    public checkfilterBoolSiNo($event: any, column_name: string) {
        const $target = <HTMLInputElement>$event.target || null;
        let filter_value = $event.value || $event.value === '' ? $event.value : $target.value;

        //        if (filter_value !== '') {
        //            filter_value = (filter_value.substr(0,1).toUpperCase() === 'S'?'true':'false');
        //        }
        //        
        this.col_filter[column_name] = filter_value;
        this.current_filter = [
            { value: filter_value, column_name: column_name }
        ];
 
        this._checkfilterValue(filter_value, column_name);

    }

    // -------------------------------------------------------------------------
    public checkfilterBool($event: any, e: any, column_name: string, disable=false) {
        let search_value = '';
        let filter_value: ''|boolean = '';
        
        if (disable) {
            filter_value = '';
            this.col_filter[column_name] = '';
        } else {
            filter_value = $event.checked;
            this.col_filter[column_name] = $event.checked;
        }

        this.current_filter = [
            { value: filter_value, column_name: column_name }
        ];

        this._checkfilterValue(filter_value, column_name);

    }

    // -------------------------------------------------------------------------
    private _checkfilterValue(filter_value: any, column_name: string) {

        AbstractMarterialTableListWithFilter.addFilter(column_name, filter_value);

        this.list_data.filterPredicate = (data: any, filter: any) => {
            return AbstractMarterialTableListWithFilter.getFilterPredicateFuntion(data, filter);
        };
        // Si se pasa como filter_value un valor nulo o undefined no llama a FilterPredicate
        // así que si quitamos un filtro, los elimina todos.
        // Como queremos que simepre mire si quedan más filtros en otras columnas
        // ponemos un filtro fictício para forzar que llame siempre a filterPredicate.
        // En MarterialTableList.getFilterPredicateFuntion no usamos este valor ya que se usar el array
        // de filtros MarterialTableList.filters, que ya hemos rellemado antes en  MarterialTableList.addFilter
        if (filter_value === '') {
            this.list_data.filter = '';
        } else {
            this.list_data.filter = 'force check';
        }
        if (this.list_data.paginator) {
            this.list_data.paginator.firstPage();
        }

    }

    // -------------------------------------------------------------------------
    public checkGlobalFilter(event: Event) {
        const filter_value = (event.target as HTMLInputElement).value;
        console.log('filter value: ' + filter_value);
        this.list_data.filter = filter_value.trim().toLowerCase();

    }

    // -------------------------------------------------------------------------
    protected override _setListaData(new_rows: any[]): void {

        setTimeout(() => {
            this._checkfilterValue('', '');
            if (this.current_filter.length) {
                const f_data = this.current_filter[0];
                this.col_filter[f_data.column_name] = f_data.value;
                if (this.current_filter.length) {
                    this._checkfilterValue(f_data.value, f_data.column_name)
                }
            }
        }, 10);
        super._setListaData(new_rows);

    }

    // ---------------------------------------------------------------------------
    protected static _validateFilter(column_name: string, data: any, filter: any): boolean {

        switch (typeof filter) {
            case 'string':
                return this._validateFilterString(column_name, data, filter);
            break;
            case 'boolean':
                return this._validateFilterBoolean(column_name, data, filter);
            break;
            default:
                return this._validateFilterDate(column_name, data, filter);
            break;

        }
//        if (typeof filter === "string") {
//            let data_search = '';
//            if (column_name == 'generic') {
//                for (const v in data) {
//                    data_search += data[v];
//                }
//            } else {
//                data_search += data[column_name]
//            }
//            data_search = data_search.trim().toLowerCase()
//            return (data_search.indexOf(filter) !== -1)
//
//        } else {    // es un date
//
//            
//
//        }

    }
    
    // ---------------------------------------------------------------------------
    protected static _validateFilterString(column_name: string, data: any, filter: any): boolean {
        let data_search = '';

        if (column_name == 'generic') {
            for (const v in data) {
                data_search += data[v];
            }
        } else {
            data_search += data[column_name]
        }
        data_search = data_search.trim().toLowerCase()

        return (data_search.indexOf(filter) !== -1)

    }

    // ---------------------------------------------------------------------------
    protected static _validateFilterBoolean(column_name: string, data: any, filter: boolean): boolean {
        let found = false;

        if (column_name == 'generic') {
            for (const c_name in data) {
                if (data[c_name] === filter) {
                    found = true;
                    break;
                }
                return found;
            }
        } else {
            found = (data[column_name] === filter);
        }
        
        return found;

    }

    // ---------------------------------------------------------------------------
    protected static _validateFilterDate(column_name: string, data: any, filter: any): boolean {
        if (filter.length === 2) { // es un daterage

            if (filter === '') return true;

            column_name += AbstractMarterialTableListWithFilter._original_sufix;
            data[column_name].setHours(2);
            filter[0].setHours(0);
            filter[1].setHours(23);
            filter[1].setMinutes(59);
            const field_date = data[column_name].getTime();
            return (field_date >= filter[0].getTime() && field_date <= filter[1].getTime());

        } else {  // Es un date normal? => pendiente de probar
            return false;
        }

    }


}